import React, { Component } from 'react';
import { toast } from 'react-toastify';
import debounce from 'lodash.debounce';
import { PiArrowsOutThin, } from "react-icons/pi";
import InfiniteScroll from 'react-infinite-scroller';
import SearchSharpIcon from "@material-ui/icons/SearchSharp";
import { Modal, Row, Button, InputGroup, FormControl, Form } from 'react-bootstrap';
import PreviewThumbnail from "../../../component/preview/preview";
import imageDefault from "../../../assets/campaign-thumbnail-phishing.png";
import axios from '../../../axios';
import './import-email-from-store.css';

export default class ImportEmailFromStore extends Component {
    constructor(props) {
        super(props);
        this.emailCardRef = React.createRef();
        this.state = {
            search: "",
            page: 1,
            templates: [],
            hasMore: true,
            disabled: true,
            selectedTemplateId: null,
            categories: [],
            languages: [],
            selectedLanguageId: "",
            selectedCategoryId: "",
            attackType: null,
            showModal: false,
            currentSrc: '',
            showThumbnail: false,
            templateImg: '',
            totalCount: 0
        };
        this.loadEmailTemplatesDebounced = debounce(this.loadEmailTemplatesDebounced.bind(this), 500);
    }



    loadEmailTemplates = () => {
        if (!this.props.showImportModal) return;

        const { page, search, selectedLanguageId, selectedCategoryId } = this.state;
        axios.post(`/api/store/list-emails`, { page, search, languageId: selectedLanguageId, categoryId: selectedCategoryId, attackType: this.props.attackType })
            .then(response => response.data)
            .then(responseData => {
                if (!this.props.showImportModal) return;

                if (responseData && responseData.response) {
                    if (this.state.selectedTemplateId && !responseData.response.some(template => template.id === this.state.selectedTemplateId)) this.setState(({ selectedTemplateId: "" }))
                    this.setState(prevState => ({
                        templates: [...prevState.templates, ...responseData.response],
                        hasMore: responseData.response.length >= 10,
                        page: prevState.page + 1,
                        totalCount: responseData.totalCount
                    }));
                } else {
                    this.setState({ hasMore: false });
                }
            })
            .catch(err => console.log(err));
    }
    loadCategory = () => {
        axios.get("/api/store/fetch-categories", {})
            .then((res) => {
                this.setState({ categories: res.data.response });
            })
            .catch(err => console.log(err));
    };

    loadLanguage = () => {
        axios.get("/api/store/fetch-languages", {})
            .then((res) => {
                this.setState({ languages: res.data.response });
            })
            .catch(err => console.log(err));
    };

    componentDidMount() {
        if (this.props.showImportModal) this.loadEmailTemplates();
        this.loadCategory();
        this.loadLanguage();
    }
    loadEmailTemplatesDebounced = (search, selectedLanguageId, selectedCategoryId) => {
        if (!this.props.showImportModal) return;

        axios.post(`/api/store/list-emails`, { page: 1, search, languageId: selectedLanguageId, categoryId: selectedCategoryId, attackType: this.props.attackType })
            .then(response => response.data)
            .then(responseData => {
                if (!this.props.showImportModal) return;

                if (responseData && responseData.response) {
                    this.setState(prevState => ({
                        templates: responseData.response,
                        hasMore: true,
                        page: 2
                    }));
                    if (this.emailCardRef.current) {
                        this.emailCardRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                } else {
                    this.setState({ hasMore: false });
                }
            })
            .catch(err => console.log(err));
    }
    componentDidUpdate(prevProps, prevState) {
        const {
            search,
            selectedLanguageId,
            selectedCategoryId,
        } = this.state;

        // Check for search change
        if (prevState.search !== search) {
            this.loadEmailTemplatesDebounced(search, selectedLanguageId, selectedCategoryId);
        }
        // Check for language or category change
        else if (prevState.selectedLanguageId !== selectedLanguageId || prevState.selectedCategoryId !== selectedCategoryId) {
            this.setState({ templates: [] });
            if (this.emailCardRef.current) {
                this.emailCardRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            this.loadEmailTemplates();
        }

        // Check for showImportModal prop change
        if (prevProps.showImportModal !== this.props.showImportModal) {
            if (this.props.showImportModal) {
                this.loadEmailTemplates();
            } else {
                this.setState({
                    search: "",
                    page: 1,
                    hasMore: true,
                    disabled: true,
                    selectedTemplateId: null,
                    selectedLanguageId: "",
                    selectedCategoryId: "",
                    templates: []
                });
            }
        }
    }

    loadHtml = (templateId) => {
        axios.get(`/api/store/fetch-email/${templateId}`)
            .then(response => response.data)
            .then(responseData => {
                if (responseData && responseData.response) {
                    const { html, subject, emailTracking, attachments } = responseData.response;
                    const attachmentNames = attachments.map(attachment => attachment.filename);
                    this.props.handleLoadSelectedStoreTemplateHtml(html, subject, emailTracking, attachmentNames, this.state.selectedTemplateId);
                    this.props.handleClose();
                } else {
                    toast.error('Template HTML not found');
                }
            })
            .catch(err => console.log(err));
    }

    handleCardClick = () => {
        this.loadHtml(this.state.selectedTemplateId);
    }

    render() {

        const { templates, hasMore, selectedTemplateId } = this.state;
        const { showImportModal, handleClose } = this.props;

        return (
            <>
                <Modal className="info-filter mainfooterModal emailRight right" style={{ overflowY: 'auto' }} show={showImportModal} onHide={handleClose} autoFocus keyboard>
                    <Modal.Header closeButton>
                        <div>
                            <h5>Email Template</h5>
                        </div>
                    </Modal.Header>
                    <div className="filter-wrapper">
                        <div className="alignItemsCenter row">
                            <div className="col-md-3 p-0">
                                <div className="positionSearchIcon">
                                    <InputGroup className="search-wrap">
                                        <FormControl type="text" placeholder="Search" value={this.state.search} onChange={e => this.setState({ search: e.target.value, page: 1 })} className="inputSearch mr-sm-2 form-control" /><SearchSharpIcon className="search-icon"></SearchSharpIcon>
                                    </InputGroup>
                                </div>
                            </div>
                            <div className="col-md-9 pr-0" style={{ display: 'flex' }}>
                                <div className="col-md-9 pr-0">
                                    <div className="rightFilters">
                                        <Form.Group controlId="exampleForm.ControlSelect1" onChange={(e) => this.setState({ selectedLanguageId: e.target.value, page: 1 })} className="d-inline-block">
                                            <Form.Control as="select" className="mr-0 btn">
                                                <option value="">Language</option>
                                                {this.state.languages.map((lang, index) => (
                                                    <option key={index} value={lang.id}>{lang.name}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </div>
                                </div>
                                <div>
                                    <div >
                                        <Form.Group controlId="exampleForm.ControlSelect1" onChange={(e) => this.setState({ selectedCategoryId: e.target.value, page: 1 })} className="d-inline-block">
                                            <Form.Control as="select" className="mr-0 btn">
                                                <option value="">Category</option>
                                                {this.state.categories.map((category, index) => (
                                                    <option key={index} value={category.id}>{category.name}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>


                    <Modal.Body>
                        <InfiniteScroll
                            pageStart={0}
                            loadMore={this.loadEmailTemplates}
                            hasMore={showImportModal && hasMore && templates.length > 0}
                            loader={<div className="loader" key={0}>Loading.....</div>}
                            useWindow={false}
                        >
                            <Row className='emailCard' ref={this.emailCardRef}>
                                {(templates?.length > 0) ? (templates.map((template, index) => (
                                    <div key={index} className='col-md-4 p-0'>
                                        <div className="img-hover-wrap templateView" >
                                            <div className={`cardWrap ${this.state.selectedTemplateId === template.id ? 'selectActive' : ''}`}
                                                style={{
                                                    position: 'relative',
                                                    cursor: 'pointer',
                                                    boxShadow: selectedTemplateId === template.id ? '0 5px 10px rgba(0, 0, 0, 0.3)' : '0 1px 3px rgba(0, 0, 0, 0.2)',
                                                    transform: selectedTemplateId === template.id ? 'scale(0.98)' : 'scale(1)',
                                                    transition: 'transform 0.1s, box-shadow 0.1s'
                                                }}
                                                onClick={() => this.setState({ selectedTemplateId: template.id })}
                                            >
                                                <img src={!template?.thumbnail ? imageDefault : template.thumbnail} className="img-fluid" alt=""></img>
                                                <div className='hover-btn' onClick={e => {
                                            if (template?.thumbnail) {
                                                this.setState({
                                                    showThumbnail: true,
                                                    currentSrc: template?.thumbnail,
                                                });
                                            } else {
                                                toast.info('Email Template Image Not Available');
                                            }
                                        }}>
                                                    <PiArrowsOutThin className="btn-icon" />
                                                </div>
                                                <div className='cardContent'>
                                                    <h6>{template.name}</h6>
                                                    <div className='cardfooterBox'>
                                                        <span className='badge badgeTwo'>{template.category}</span>
                                                        <span className='badge badgeOne'>{template.language}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))) : ("No data found")}
                            </Row>
                        </InfiniteScroll>
                    </Modal.Body>
                    <div className="modalFooter" style={{ paddingRight: "0px" }}>
                            <div className="col-md-6">
                                <p className="selectedTemp mb-0">Total: {this.state.totalCount}</p>
                            </div>
                            <div className="col-md-6 text-right">
                                <Button onClick={handleClose} type="button" className="btn closeBtn">Cancel</Button>
                                <Button disabled={this.state.selectedTemplateId ? false : true} className='btn btn-success ml-2' onClick={() => this.handleCardClick()}>Select Template</Button>
                            </div>
                    </div>
                </Modal>

                <PreviewThumbnail
                    src={this.state.currentSrc}
                    attackType={this.props.attackType}
                    showModal={this.state.showThumbnail}
                    showHandle={e => this.setState({ showThumbnail: false })}
                    template={this.state.previewTemplate} // add this line
                />
            </>
        );
    }
}
